export default "mutation RequestFreeTrialBiologics($request: RequestFreeTrialBiologics!) {\n  requestFreeTrialBiologics(request: $request)\n}";